import React, { Component } from 'react'
import { TryMap } from '../index'
import '../../css/responsive.css';
class UpdateRoute extends Component {
    //#region ######### ONCHANGE FIELDS  ############################################################
    RefreshRouteDocModel = async (RouteDoc) => {
        const { RefreshRouteDocModel } = this.props
        await RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteCode = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Code = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteName = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Name = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeSeller = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.SlpCode = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeComment = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Comment = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteStatus = () => {
        const { RouteDoc } = this.props
        RouteDoc.IsActive = !RouteDoc.IsActive;
        this.RefreshRouteDocModel(RouteDoc);
    }

    //#endregion



    render() {
        const { Waypoints, Routes, auxSeller, Sellers, GetRoutePoints, UnassignedPartners, RouteDoc, ChangeEditedRouteStatus, SetData, SaveUpdatedRoute, AddPartnerToRoute, DeleteEditedPartners } = this.props

        return (
            <div className='m-5'>
                <div id="create-Route-form" style={{ marginTop: "2vh" }}>
                    <div class="content-wrapper">
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div className='row'>
                                <div class="col-md-4 col-lg-4 order-0 mb-4">
                                    <div class="card h-100">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h5 class="card-title m-0 me-2">Rutas creadas</h5>
                                        </div>
                                        <div class="card-body scrollCardBP" >
                                            <ul class="p-0 m-0">
                                                {Routes && Routes.map((route, index) => {
                                                    return (
                                                        <li key={index} class="d-flex mb-4 pb-1" onClick={() => GetRoutePoints(route)}>
                                                            <div class="avatar flex-shrink-0 mr-2 ml-2 mt-2" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                                                                <img style={{ height: "2.5vh" }}
                                                                    src={require('../../images/ico/routeMap.png')} alt="User" class="rounded" />
                                                            </div>
                                                            <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                <div class="me-2">
                                                                    <small class="text-muted d-block mb-1">{route.RouteName}</small>
                                                                    <h6 class="mb-0">{route.RouteCode} </h6>
                                                                </div>
                                                                <div class="user-progress d-flex align-items-center gap-1 mr-2">
                                                                    {
                                                                        route.IsActive === 1 ?
                                                                            <i className="fa fa-arrow-up" style={{ color: "#2dbb55" }} ></i>
                                                                            :
                                                                            <i className="fa fa-arrow-down" style={{ color: 'red' }} ></i>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8 mb-4 order-2">
                                    <div class="card">
                                        <div class="d-flex align-items-end row">
                                            <div class="col-sm-12">
                                                <div class="card-body" >
                                                    {/* <h5 class="card-title text-primary">MARINROCKS RULES! </h5> */}
                                                    <div style={{ height: '400px', }}>
                                                        <TryMap
                                                            waypoints={Waypoints}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div class="col-lg-8 mb-4 order-0">
                                    <div class="card">
                                        <div class="d-flex align-items-end row">
                                            <div class="col-sm-12">
                                                <div class="card-body">
                                                    <h5 class="card-title text-primary">Editar Ruta </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Código de la ruta</label>
                                                            <input
                                                                disabled={true}
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Código"
                                                                value={RouteDoc && RouteDoc.Code !== '' ? RouteDoc.Code : ''}

                                                            />

                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Nombre de la ruta</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nombre"
                                                                value={RouteDoc && RouteDoc.Name !== '' ? RouteDoc.Name : ''}
                                                                onChange={(event) => this.ChangeRouteName(event.target.value)}
                                                            />
                                                            {/* <small id="emailHelp" class="form-text text-muted">Cuidado con el nombre que asignes, no podrá ser modificado posteriormente.  </small> */}
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-8'>
                                                            <label for="exampleInputEmail1">.</label>
                                                            <select
                                                                id="toggleCostumer"
                                                                className="form-control"
                                                                value={RouteDoc && RouteDoc.SlpCode !== '' ? RouteDoc.SlpCode : ''}
                                                                onChange={(event) => this.ChangeSeller(event.target.value)}
                                                            >
                                                                <option>Seleccione el vendedor responsable</option>

                                                                {Sellers && Sellers.map((seller, index) => {
                                                                    return (
                                                                        <option key={index} value={seller.salesPrson}>
                                                                            {seller.firstName}.- {seller.lastName}. Posición: {seller.name}
                                                                        </option>
                                                                    )
                                                                })
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className='col-sm-4'>

                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Comentario</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Comentario"
                                                                value={RouteDoc && RouteDoc.Comment !== '' ? RouteDoc.Comment : ''}
                                                                onChange={(event) => this.ChangeComment(event.target.value)}
                                                            />
                                                            {/* <small id="emailHelp" class="form-text text-muted">Cuidado con el nombre que asignes, no podrá ser modificado posteriormente.  </small> */}
                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Activa</label>
                                                            <div class="form-switch" style={{ position: "relative", display: "block", paddingLeft: "2.5rem" }}>
                                                                <input
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    onChange={() => this.ChangeRouteStatus()}
                                                                    checked={RouteDoc.IsActive}
                                                                />
                                                                <label class="form-check-label" for="flexSwitchCheckChecked" style={{ paddingLeft: "1.5rem", textAlign: "center", paddingTop: ".5em" }}></label>
                                                            </div>
                                                            {/* <small id="emailHelp" class="form-text text-muted">Cuidado con el nombre que asignes, no podrá ser modificado posteriormente.  </small> */}
                                                        </div>
                                                    </div>
                                                    <h5 class="card-title text-primary mt-2 mb-2">Clientes dentro de la ruta  </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-12'>
                                                            <div class="scrollAddesdBP">
                                                                <ul class="p-0 m-0">
                                                                    {RouteDoc && RouteDoc.RoutesLines.length > 0 ?
                                                                        RouteDoc.RoutesLines.map((editDocLine, index) => {
                                                                            return (
                                                                                <li class="d-flex mb-4 pb-1">
                                                                                    <div class="avatar flex-shrink-0 me-3" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                                                                                        <img style={{ width: '2vh' }}
                                                                                            src={'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgNnZ6Q2MMqUFjsRkB7ZwdfwlhBql67_ebF46l25PgvazKuDalqwBZzo3Wltq6P8nU8lE7YcOHxRXP7VwRZghOST63xQzp73XHM4dhlG-pfBS9UTtD5qBTos6kDFLGeRkzINwAZDA7bRA1utG-Nf6uZBWo60CEPLZC2weuxkdGFFcNIJvy0hWM0vRhV/w945-h600-p-k-no-nu/userIcon.png'} alt="User" class="rounded" />
                                                                                    </div>
                                                                                    <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                        <div class="me-2">
                                                                                            <small class="text-muted d-block mb-1">{`Latitud: ${editDocLine.U_FMB_GPSLat}  Longitud: ${editDocLine.U_FMB_GPSLon}`}</small>
                                                                                            <h6 class="mb-0">{editDocLine.CardCode}</h6>
                                                                                        </div>
                                                                                        <div class="user-progress d-flex align-items-center gap-1">
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                type="button"
                                                                                                style={{ backgroundColor: "#223555", color: "white" }}
                                                                                                onClick={() => DeleteEditedPartners(index, editDocLine)}
                                                                                            >
                                                                                                <i className="fa fa-trash-o"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                        : ''
                                                                    }
                                                                </ul>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="row mt-2 ">
                                                        <div class="col-12 text-right mb-1">
                                                            <button
                                                                type="button"
                                                                class="btn"
                                                                style={{ color: "black !important", background: "#ffc107" }}
                                                                onClick={() => SaveUpdatedRoute()}
                                                            >Editar Ruta</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4 order-2 mb-4">
                                    <div class="card h-100">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h5 class="card-title m-0 me-2">Agregar cliente</h5>
                                        </div>
                                        <div class="card-body " >
                                            <div className='scrollCardBP'>
                                                <ul class="p-0 m-0">
                                                    {UnassignedPartners ?
                                                        UnassignedPartners.map((costumer, index) => {
                                                            return (
                                                                <li key={index} class="d-flex mb-4 pb-1">
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style={{width: "35px"}}>
                                                                                    <div class="" >
                                                                                        <i class="fa fa-user" aria-hidden="true"></i>
                                                                                        {/* <img src={'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgNnZ6Q2MMqUFjsRkB7ZwdfwlhBql67_ebF46l25PgvazKuDalqwBZzo3Wltq6P8nU8lE7YcOHxRXP7VwRZghOST63xQzp73XHM4dhlG-pfBS9UTtD5qBTos6kDFLGeRkzINwAZDA7bRA1utG-Nf6uZBWo60CEPLZC2weuxkdGFFcNIJvy0hWM0vRhV/w945-h600-p-k-no-nu/userIcon.png'} alt="User" class="rounded" /> */}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                        <div class="mr-2">
                                                                                            <small class="text-muted d-block mb-1">{costumer.CardName}</small>
                                                                                            <h6 class="mb-0">{costumer.CardCode} </h6>
                                                                                        </div>
                                                                                        <div class="user-progress d-flex align-items-center gap-1 mr-2">
                                                                                            <button
                                                                                                className="btn btn-outline-success"
                                                                                                type="button"
                                                                                                onClick={() => AddPartnerToRoute(costumer, index)}
                                                                                            >
                                                                                                <i className="fa fa-plus"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </li>
                                                            );

                                                        })
                                                        : ''
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="content-backdrop fade"></div>
                    </div>
                </div>


            </div>
        )
    }
}

export default UpdateRoute